// АВТОГЕНЕРИРОВАННЫЙ ФАЙЛ — НЕ РЕДАКТИРУЙТЕ ВРУЧНУЮ.
// Источник правды: data-source/korpy_balance_v6.xlsx
// Регенерация: npm run gen-cards (или двойной клик по tools/gen-cards.bat)
// Сгенерировано: 2026-06-03T21:08:21.159Z

export const heroes = [
  {
    "id": "livlife_ariana",
    "name_ru": "Главврач Ариана",
    "name_en": "Chief Doctor Ariana",
    "faction": "livlife",
    "type": "hero",
    "rarity": "special",
    "archetype": "Ремонтник через возврат",
    "exclusive_hero": null,
    "atk": 1,
    "armor": 2,
    "hp": 15,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "active": "1× за матч (Ф2): заполнить все свободные ячейки своей стороны Медтехами LL-1",
      "trigger": "В начале своего хода (раз в 2 хода: ходы 2, 4, 6, 8): возвращает раненого союзника в руку с восстановленным max hp/armor (баффы и keyword'ы сохраняются), игрок ставит карту юнита из руки на свободную ячейку. Если в руке только Действия — постановка отменяется. Если рука полная — триггер не срабатывает"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "turn_start",
      "target": "ally_lowest_hp",
      "effect": "composite",
      "value": "return_to_hand:keep_buffs_full_restore@ally_lowest_hp|summon:from_hand_unit_card@own_line",
      "condition": "turn_number_even_and_hand_not_full_and_has_unit_in_hand"
    },
    "dsl_trigger2": null,
    "dsl_active": {
      "target": "all_empty_slots",
      "effect": "fill_line_with_summon",
      "value": "livlife_medtekh_ll1",
      "uses": "1"
    },
    "dsl_aura": null,
    "flavor_ru": "«Спасают всех. Кроме тех, кто не может оплатить страховку.»",
    "ability_text_en": {
      "active": "1× per match (Phase 2): fill all free slots on your side with Medtech LL-1",
      "trigger": "At the start of your turn (every 2 turns: turns 2, 4, 6, 8): returns a wounded ally to your hand with restored max hp/armor (buffs and keywords are kept); the player places a unit card from hand onto a free slot. If the hand has only Actions, the placement is canceled. If the hand is full, the trigger doesn't fire"
    }
  },
  {
    "id": "livlife_klod",
    "name_ru": "Био-инженер Клод",
    "name_en": "Bio-engineer Claude",
    "faction": "livlife",
    "type": "hero",
    "rarity": "special",
    "archetype": "Эпидемиолог",
    "exclusive_hero": null,
    "atk": 2,
    "armor": 2,
    "hp": 12,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "active": "1× за матч (Ф2): 3 урона всем вражеским юнитам с keyword «Заражён», после удара keyword снимается со всех целей",
      "trigger": "В начале своего хода: накладывает 1 стак Заражения на случайного вражеского юнита. Стак до 3, в начале каждого своего хода юнит получает 1 урон за каждый стак. Снимается Молчанием. При смерти инфицированного keyword не передаётся"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "turn_start",
      "target": "enemy_random",
      "effect": "infect",
      "value": "1"
    },
    "dsl_trigger2": null,
    "dsl_active": {
      "target": "enemy_infected_aoe",
      "effect": "composite",
      "value": "damage:3@enemy_infected_aoe|remove_keyword:infected@enemy_infected_aoe",
      "uses": "1"
    },
    "dsl_aura": null,
    "flavor_ru": "«Медицина — это распределение. Кому лечение. Кому диагноз.»",
    "ability_text_en": {
      "active": "1× per match (Phase 2): 3 damage to all enemy units with the «Infected» keyword; after the hit, the keyword is removed from all targets",
      "trigger": "At the start of your turn: applies 1 Infection stack to a random enemy unit. Stacks up to 3; at the start of each of your turns the unit takes 1 damage per stack. Removed by Silence. When the infected unit dies, the keyword isn't passed on"
    }
  },
  {
    "id": "livlife_lisa",
    "name_ru": "Генетик Лиза",
    "name_en": "Geneticist Lisa",
    "faction": "livlife",
    "type": "hero",
    "rarity": "special",
    "archetype": "Воскрешатель",
    "exclusive_hero": null,
    "atk": 2,
    "armor": 1,
    "hp": 12,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "active": "1× за матч (Ф2): воскресить любого юнита из любого сброса (своего или вражеского, открытый выбор) с full hp на свободную ячейку своей стороны. Воскрешённый вражеский юнит играет за тебя",
      "trigger": "В начале своего хода (раз в 2 хода): воскресить случайного юнита из своего сброса с full hp на случайную свободную ячейку своей стороны. Если в сбросе только Действия — пропуск. Воскрешение запускает фракционный хил"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "turn_start",
      "target": "own_discard_random_unit",
      "effect": "resurrect",
      "value": "full_hp@random_empty_own_slot",
      "condition": "turn_number_even_and_own_discard_has_unit"
    },
    "dsl_trigger2": null,
    "dsl_active": {
      "target": "any_discard_choose_unit",
      "effect": "resurrect",
      "value": "full_hp@own_empty_slot",
      "uses": "1"
    },
    "dsl_aura": null,
    "flavor_ru": "«ДНК — это не рецепт. Это контракт.»",
    "ability_text_en": {
      "active": "1× per match (Phase 2): resurrect any unit from any discard (yours or the enemy's, open choice) with full hp to a free slot on your side. A resurrected enemy unit fights for you",
      "trigger": "At the start of your turn (every 2 turns): resurrect a random unit from your discard with full hp to a random free slot on your side. If the discard has only Actions, skip. The resurrection triggers the faction heal"
    }
  },
  {
    "id": "livlife_zayn",
    "name_ru": "Нейро-хирург Зейн",
    "name_en": "Neuro-surgeon Zane",
    "faction": "livlife",
    "type": "hero",
    "rarity": "special",
    "archetype": "Конвертер хила в урон",
    "exclusive_hero": null,
    "atk": 3,
    "armor": 1,
    "hp": 12,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "active": "1× за матч (Ф2): все союзные юниты на этот ход меняют местами атаку и hp, max_armor становится 0. В начале следующего хода всё откатывается обратно",
      "trigger": "В конце своего хода: счётчик «сколько разных союзных юнитов получили хил в этом ходу» = N. N разделённых ударов по 1 урона случайным юнитам противника. Если N=0 — триггер не срабатывает"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "turn_end",
      "target": "enemy_random",
      "effect": "damage_split_per_healed_count",
      "value": "1_per_healed_unit_this_turn"
    },
    "dsl_trigger2": null,
    "dsl_active": {
      "target": "ally_aoe_all",
      "effect": "swap_atk_hp_zero_armor",
      "duration": "until_end_of_turn",
      "uses": "1"
    },
    "dsl_aura": null,
    "flavor_ru": "«Я не лечу. Я переделываю.»",
    "ability_text_en": {
      "active": "1× per match (Phase 2): for this turn all allied units swap their attack and hp, and max armor becomes 0. At the start of the next turn everything reverts",
      "trigger": "At the end of your turn: count «how many different allied units were healed this turn» = N. N split hits of 1 damage to random enemy units. If N=0, the trigger doesn't fire"
    }
  }
];
